import {Action} from 'com/gongxigames/math/core/game/enums/Action';
import {FlowRespinState} from '@gongxigames/framework/slot/modules/flow/states/FlowRespinState';
import {GenericPopupEvents, GenericPopupType} from '@gongxigames/framework/slot/modules/genericPopup';
import {FlowModuleEvents} from '@gongxigames/framework/slot/modules/flow/FlowModuleEvents';
import {FlowModule} from '@gongxigames/framework/slot/modules/flow/FlowModule';
import { BigWinEvents} from '@gongxigames/framework/slot/modules/bigwin';
import {WinPresentationEvents} from '@gongxigames/framework/slot/modules/winpresentation';

export class FlowRespinInFreespinsState extends FlowRespinState {
    protected setupEvents(): void {
        super.setupEvents();

        this.setEventHandler(GenericPopupEvents.POPUP_CLOSED, this.onPopupClosed.bind(this));
    }

    protected onPopupClosed(type: symbol): void {
        if (type === GenericPopupType.FREESPIN_OUTRO) {
            this.onFreeSpinsOutroFinished();
        }
    }

    protected onAllReelsStopped(): void {
        this.clearEventsQueue();

        switch (this.module.logic.nextAction) {
            case Action.SPIN: {
                this.emit(FlowModuleEvents.NO_RESPIN_ON_NEXT_SPIN);
                this.setupEndFreeSpinsSequence();
                break;
            }

            case Action.RESPIN: {
                this.setupRespin();
                break;
            }

            case Action.FREESPIN: {
                this.emit(FlowModuleEvents.NO_RESPIN_ON_NEXT_SPIN);
                this.module.gotoState(FlowModule.FREE_SPINS_STATE);
                this.setupLinesWinMainGameSequence();
                break;
            }

            default:
                break;
        }
    }

    protected onFreeSpinsOutroFinished(): void {
        this.restoreFreeSpinsWinningRoundSession();

        if (this.isBigWinFromAllFreeSpins()) {
            this.emit(FlowModuleEvents.BIG_WIN_AFTER_FREE_SPINS_STARTED);
            this.addCallbackToWaitingLIst(BigWinEvents.FINISHED, this.onBigWinAfterFreeSpinsFinished.bind(this));
        } else {
            this.module.gotoState(FlowModule.BASIC_STATE);
        }
    }

    protected restoreFreeSpinsWinningRoundSession(): void {

    }

    protected onBigWinAfterFreeSpinsFinished(): void {
        this.module.gotoState(FlowModule.BASIC_STATE);
    }

    protected isBigWinFromAllFreeSpins(): boolean {
        return this.module.logic.isBigTotalWin();
    }

    protected setupEndFreeSpinsSequence(): void {
        if (this.isWin()) {
            if (this.isBigWin()) {
                this.setupBigWinAfrerOnFreeSpinsEnd();
            } else {
                this.setupWinInFreeSpinsEnd();
            }
        } else {
            this.setupNoWinOnFreeSpinsEnd();
        }
    }

    protected setupBigWinAfrerOnFreeSpinsEnd(): void {
        this.emit(FlowModuleEvents.WON);
        this.emit(FlowModuleEvents.WON_BIG_WIN);
        this.addEventToWaitingList(BigWinEvents.FINISHED, FlowModuleEvents.FREE_SPINS_FINISHED);
        this.addEventToWaitingList(GenericPopupEvents.POPUP_CLOSED, FlowModuleEvents.CAN_SPIN);
    }

    protected setupWinInFreeSpinsEnd(): void {
        this.emit(FlowModuleEvents.WON);
        this.addEventToWaitingList(WinPresentationEvents.INITIAL_ANIMATION_FINISHED,
            FlowModuleEvents.SHOULD_START_INDIVIDUAL_WIN_FREESPINS);
        this.addEventToWaitingList(WinPresentationEvents.PAY_ANIMATIONS_AND_WIN_METER_FINISHED, FlowModuleEvents.FREE_SPINS_FINISHED);
        this.addEventToWaitingList(WinPresentationEvents.ALL_PAY_ANIMATIONS_FINISHED, FlowModuleEvents.FREE_SPINS_FINISHED);
        this.addEventToWaitingList(GenericPopupEvents.POPUP_CLOSED, FlowModuleEvents.CAN_SPIN);
    }

    protected setupNoWinOnFreeSpinsEnd(): void {
        this.emit(FlowModuleEvents.NO_WIN);
        this.emit(FlowModuleEvents.CAN_SPIN);
        this.emit(FlowModuleEvents.FREE_SPINS_FINISHED);
    }
}
